import { render, staticRenderFns } from "./ContainerPoi.vue?vue&type=template&id=b56eb7b4&scoped=true&"
import script from "./ContainerPoi.vue?vue&type=script&lang=js&"
export * from "./ContainerPoi.vue?vue&type=script&lang=js&"
import style0 from "./ContainerPoi.vue?vue&type=style&index=0&id=b56eb7b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56eb7b4",
  null
  
)

export default component.exports